import React from "react";
import queryString from 'query-string';
import axios from 'axios';

import { withT, TProps } from 'lib/i18n';
import './NewsletterUnsubscribe.scss';


const NewsletterUnsubscribe = ({ t }: TProps) => {
	React.useEffect(() => {
		(async () => {
			const apiUrl = process.env.REACT_APP_API_URL;
			const params = queryString.parse(window.location.search);
			const apiCall = apiUrl + '/v1/newsletter/unsubscribe?' + queryString.stringify(params);

			try {
				const { data: resJson } = await axios.post(apiCall);

				if (resJson.error) {
					console.error(`Some error happened trying this query [${apiCall}] : ${JSON.stringify(resJson)}`);
				}

			} catch (error) {
				console.error(error);
			}
		})();
	}, []);

	return (
		<div id="unsubscribeContent">
			{t('newsletter.optout')}
		</div>
	);
};

export default withT(NewsletterUnsubscribe);
